import SEO from '../components/SEO';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <SEO
        title="Cambodia's Super App for Marketplace, Business, Jobs & Community"
        description="Connect with Cambodia's leading platform for marketplace, businesses, property, education, jobs, and charity. Empowering communities through technology."
        keywords={[
          'Cambodia marketplace',
          'Cambodian business directory',
          'property Cambodia',
          'education Cambodia',
          'charity Cambodia',
          'jobs Cambodia',
          'Cambodia job board',
          'Khmer app',
          'Cambodian super app',
        ]}
      />
      {/* Skip to main content link for keyboard navigation */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg"
      >
        Skip to main content
      </a>
      <Navigation />
      <main id="main-content">
        <Hero />
        <About />
        <Services />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
